<template>
        <span>

                <el-dialog
                        title="制定临时任务"
                        width="65%"
                        top="60px"
                        :bottom="0"
                        append-to-body
                         style="max-hight:100vh;margin-bottom:0"
                        v-if="dialogVisible"
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        v-loading="loading"
                        class="taskManagement-editForm"
                        :before-close="handleClose"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        调整
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                </template>
                <div style="max-height:calc(100vh - 350px);overflow:scroll;">
                <avue-form ref="form" v-if="dialogVisible" v-model="form" :option="option" @reset-change="emptytChange" @submit="updateTask">
                        <!-- 任务日期 -->
                        <template slot="executeDate">
                                <el-date-picker
                                        v-model="form.executeDate"
                                        type="date"
                                        :picker-options="pickerOptions"

                                        placeholder="请选择 任务日期">
                                </el-date-picker>
                        </template>

                        <template slot="taskContent">
                                <div>
                                        <el-row>
                                                <selectArea  v-if="dialogVisible && form.type == 3" :taskContentData.sync="taskContentData"  :projectId.sync='form.projectId'></selectArea>
                                               <relateDevice @getDeviceInfo="getDeviceInfo" v-if="dialogVisible && form.type != 3" :taskContentData.sync="taskContentData"  :taskType.sync="form.type" :standardId='standardId' :projectId.sync='form.projectId'></relateDevice>
                                               <el-button size="small" type="primary" @click="removeSelect">移除</el-button>
                                               <el-button size="small" type="primary" @click="moveUpSelect">上移</el-button>
                                               <el-button size="small" type="primary" @click="moveDownSelect">下移</el-button>
                                        </el-row>
                                        <el-row>
                                               <avue-crud
                                               :data="taskContentData"
                                               :option="crudOption"
                                                ref="crud"
                                                :table-loading="loading"
                                                @selection-change="selectionChange"

                                               >
                                                <template slot-scope="scope" slot="name">
                                                      <span>{{scope.row.name}}</span><span v-if="scope.row.assetStatus==2" style="color:red"> (报废)</span>
                                                </template>
                                                <template slot="standardName" slot-scope="scope">
                                                        <div v-if="form.type==1">
                                                                <div v-if="!scope.row.showEdit">
                                                                        <div>{{scope.row.standardName}}</div>
                                                                        <el-button v-if="scope.row.standardName"  size="mini" type="primary" plain @click="changeStandard(scope.row)">切换标准</el-button>
                                                                </div>
                                                                <div v-else>
                                                                        <el-select  v-model="scope.row.standardId" placeholder="请选择" @change="(val)=>{
                                                                                standardChange(scope.row)}">
                                                                                <el-option
                                                                                        v-for="item in scope.row.deviceInspectStandard"
                                                                                        :key="item.id"
                                                                                        :label="item.name"
                                                                                        :value="item.id">
                                                                                </el-option>
                                                                        </el-select>
                                                                        
                                                                </div>
                                                        </div>
                                                        <div v-else><span>{{scope.row.standardName}}</span></div>
                                                </template>
                                               </avue-crud>
                                        </el-row>
                                </div>
                        </template>
                        <template slot="taskNotifyAheadNum">
                                <div>
                                        <el-input  @input="taskNotifyAheadNumInput" v-model="form.taskNotifyAheadNum" placeholder="请输入 任务通知时限">
                                                <template slot="append">
                                                        <select style="width:80px;" v-model="form.taskNotifyAheadUnit">
                                                                <option
                                                                        v-for="item in  taskNotifyAheadUnitList"
                                                                        :key="item.id"
                                                                        :label="item.dictValue"
                                                                        :value="item.dictKey">

                                                                </option>
                                                        </select>
                                                </template>
                                        </el-input>
                                        <el-row>

                                               <el-checkbox v-model="form.taskFinishPicMustFlag" true-label='1' false-label='0' >巡检时强制提交照片，数量1~4张</el-checkbox>
                                        </el-row>
                                        <el-row>

                                               <el-checkbox v-model="form.taskExecuteForceSequenceFlag" true-label='1' false-label='0'>强制按巡检内容书顺序巡检</el-checkbox>
                                        </el-row>
                                </div>

                        </template>
                        <template slot="taskOverdueTimeNum">
                                <div>
                                        <el-input  @input="taskOverdueTimeNumInput" v-model="form.taskOverdueTimeNum" placeholder="请输入 任务过期时限">
                                                <template slot="append">
                                                        <select style="width:80px;" v-model="form.taskOverdueTimeUnit">
                                                                <option
                                                                        v-for="item in  taskOverdueTimeUnitList"
                                                                        :key="item.id"
                                                                        :label="item.dictValue"
                                                                        :value="item.dictKey">

                                                                </option>
                                                        </select>
                                                </template>
                                        </el-input>
                                        <el-row>

                                               <el-checkbox v-model="form.taskOverdueCloseFlag" true-label='1' false-label='0'>逾期任务自动关闭</el-checkbox>
                                        </el-row>
                                        <el-row>

                                               <el-checkbox v-model="form.taskOverdueSubmitForbidFlag" true-label='1' false-label='0'>任务过期不允许执行</el-checkbox>
                                        </el-row>
                                </div>

                        </template>
                        <!-- <template slot-scope="scope" slot="menuForm">
                                <el-button icon="el-icon-circle-close" size="small" @click="handleClose(false)">取 消</el-button>
                        </template> -->

                </avue-form>
                </div>
                <template slot="footer">
                        <div style="text-align:right;">
                                <el-button icon="el-icon-circle-plus-outline" type="primary" size="small" @click="$refs.form.submit();">保 存</el-button>
                                <el-button icon="el-icon-circle-close" size="small" @click="handleClose(false)">取 消</el-button>
                        </div>
                </template>
                </el-dialog>
        </span>
</template>
<script>

import {

        getDictionary,
        adjustDetail,
        updateTask,
        standardDetailByDeviceId,
           getBisDictData,
        getStandardName
} from "@/api/crmedical/device/taskManagement";
import selectTime from "../components/select-time.vue";
import selectGroupUser from "../components/user-select-box.vue";
import choicePeople from '@/components/user-edit-box/user-edit-box2';
import {areaOption,deviceOption,omitNumber} from "./option.js";
import relateDevice from '../components/choice-device';
import selectArea from "../components/choice-area.vue"
export default {
        components:{selectTime,choicePeople,selectGroupUser,relateDevice,selectArea},
        props:{
                projectId:{
                        type:String,
                        default:'',
                }
        },
        data(){
                return{
                        id:"",
                        taskContentData:[],
                        taskContentDataIds:[],
                        loading:false,
                        data:[],
                        taskNotifyAheadUnitList:[],
                        taskOverdueTimeUnitList:[],
                        isEdit:false,
                        realInspectManList:[],
                        selectedTime:[],
                        dialogVisible:false,
                        dialogFull:false,
                        selectTimeFlag:false,
                        selectionData:[],
                        form:{
                                projectId:'',
                                executeUserId:[],
                        },
                        crudOption:deviceOption,
                        // 可选择日期
                        pickerOptions:{
                                disabledDate(time) {
                                        return time.getTime() < Date.now() - 8.64e7;  //如果没有后面的-8.64e7就是不可以选择今天的
                                }
                        },
                        option:{
                                size:'small',
                                menuPosition:'right',
                                emptyBtn:false,
                                submitIcon:'el-icon-circle-plus-outline',
                                submitText: '保 存',
                                submitBtn:false,
                                labelWidth:120,
                                column:[
                                        {
                                                label: "项目名称",
                                                prop: "projectId",
                                                type:'select',
                                                span:8,
                                                disabled:true,
                                                cascaderItem:['orderModuleType'],
                                                dicUrl:'/api/v4ward/project/getProjectList',
                                                props:{
                                                        label:"name",
                                                        value:'id'
                                                },
                                                rules: [{
                                                        required: true,
                                                        message: "请选择项目",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                label: "任务类型",
                                                prop: "type",
                                                span:8,
                                                disabled:true,
                                                cascaderItem:['orderModuleType'],
                                                props:{
                                                        label:'dictValue',
                                                        value:'dictKey',
                                                },
                                                dicUrl:'/api/blade-system/dict/dictionary?code=task_type',
                                                type:"select",
                                                rules: [{
                                                        required: true,
                                                        message: "请选择任务类型",
                                                        trigger: "change"
                                                }]
                                        },
                                          {
                                                label: "任务子类型",
                                                prop: "subTypeId",
                                                 dicData:[],
                                                 disabled:true,
                                                props:{
                                                        label:'dictValue',
                                                        value:'dictKey',
                                                },
                                                type:"select",
                                                span:8,

                                        },
                                        {
                                                label: "任务名称",
                                                prop: "name",
                                                type:"input",
                                                disabled:true,
                                                span:8,
                                                maxlength:20,
                                                showWordLimit:true,
                                        },
                                        {
                                                label: "开始时间",
                                                prop: "validStartTime",
                                                type: 'datetime',
                                                disabled:true,
                                                span:8,
                                        },
                                        {
                                                label: "结束时间",
                                                type: 'datetime',
                                                disabled:true,
                                                prop: "validEndTime",
                                                span:8,
                                        },
                                        {
                                                label: "计划人员",
                                                disabled:true,
                                                prop: "executeUserName",
                                                span:12,

                                        },
                                         {
                                                label: "标准名称",
                                                prop: "standardId",
                                                dicData:[],
                                                disabled:true,
                                                props:{
                                                        label:'standardName',
                                                        value:'standardId',
                                                },
                                                type:"select",
                                                span:12,
                                                rules: [{
                                                        required: true,
                                                        message: "请选择巡检标准",
                                                        trigger: "change"
                                                }],
                                                display:false
                                        },
                                        {
                                                label: "任务内容",
                                                formslot:true,
                                                // labelslot:true,
                                                rules: [{
                                                        required: true,
                                                        message: "请添加任务内容",
                                                        trigger: "change"
                                                }],
                                                prop: "taskContent",
                                                span:24,
                                                disabled:true,

                                        },
                                        {
                                                title: '分割线',
                                                component: 'el-divider',
                                                span: 24,
                                                labelWidth: '0px',
                                                params: {
                                                        html: '<h3 style=\"color:#333\">执行任务要求</h3>',
                                                        contentPosition: 'left'
                                                },
                                                prop: '1632968429167_6112'
                                        },
                                        {
                                                label: "任务通知时限",
                                                formslot:true,
                                                disabled:true,
                                                prop: "taskNotifyAheadNum",
                                                span:12,
                                        },
                                        {
                                                label: "任务过期时限",
                                                formslot:true,
                                                disabled:true,
                                                prop: "taskOverdueTimeNum",
                                                span:12,
                                        },

                                ]
                        },
                        selectIds:"",
                }
        },
        watch:{
                'form.subTypeId'(){
                        let subTypeIdColumn = this.findObject(this.option.column,"standardId");
                        if(this.form.subTypeId==''||this.form.subTypeId==undefined){
                                 subTypeIdColumn.display =false
                        }else{
                                console.log("ducu",this.form.subTypeId)
                                subTypeIdColumn.display =true
                                this.getStandardBysubTypeId(this.form.subTypeId,this.form.projectId).then(res=>{
                                        subTypeIdColumn.dicData = res
                                })
                                
                        }
                },
                "form.type"(val){


                        let subTypeIdColumn = this.findObject(this.option.column,"subTypeId");
                        if(val==1){
                                this.crudOption = deviceOption ;

                        }else if(val==2){
                                this.crudOption = deviceOption;


                        }else if(val==3){
                                this.crudOption = areaOption;
                                getBisDictData({
                                        projectId:this.form.projectId,
                                        code:'project_general_inspect_type'
                                }).then(res=>{
                                        subTypeIdColumn.dicData = res.data
                                })

                        }else{
                                  this.crudOption = areaOption;
                        }




                },
                "realInspectManList"(val){
                        if(val.length>0){
                                this.form.executeUserId = val;

                        }else{
                                this.form.executeUserId = [];
                        }
                },
                "taskContentData"(val){
                        if(val.length>0){
                                this.form.taskContent = true;
                        }else{
                                this.form.taskContent = "";
                        }
                }


        },
        created(){

        },
        methods:{
                   //根据工单子类型获取标准
               async  getStandardBysubTypeId(inspectType,projectId){
                      console.log("89898")
                        let data =[]
                     await   getStandardName({
                                projectId,
                                inspectType
                        }).then(res=>{
                                  data = res.data 
                        })
                        return data
                },
                 standardChange(row){
                        row.deviceInspectStandard.forEach(element => {
                                if(element.id == row.standardId){
                                        row.standardName =element.name
                                }
                        });
                         row.showEdit = false
                 },
                changeEnd(row){
                        row.showEdit = false
                },
                changeStandard(row){
                        console.log('kkk',row)
                        if(!row.deviceInspectStandard){
                                standardDetailByDeviceId({deviceId:row.id}).then(res=>{
                                this.$set(row,'deviceInspectStandard',res.data)
                                this.$set(row,'showEdit',true)
                        })
                        }
                        this.$set(row,'showEdit',true)
                        // row.isEdit = true
                },
                getDeviceInfo(data){
                        console.log("dddxzxcxzc")
                        if(this.form.type =='1'){
                                 data.forEach(ele=>{
                                         this.$set(ele,'showEdit',false)
                                // if(ele.deviceInspectStandard.length>0){
                                //         if(ele.standardId==''){
                                //                 ele.standardId = ele.deviceInspectStandard[0].id
                                //         }

                                // }

                        })
                        this.taskContentData =[...data]
                        console.log(this.taskContentData)
                        }

                },
                // 控制输入框输入数字
                taskNotifyAheadNumInput(e){
                        this.form.taskNotifyAheadNum = omitNumber(e)
                },
                // 控制输入框输入数字
                taskOverdueTimeNumInput(e){
                        this.form.taskOverdueTimeNum = omitNumber(e)
                },

                // 移除
                removeSelect(){
                        let temArr = [];
                        this.taskContentData.forEach((ele)=>{
                                if(this.selectIds.indexOf(ele.id)<0){
                                        temArr.push(ele)
                                }
                        })
                        setTimeout(()=>{
                                this.taskContentData = temArr;
                                this.loading = false;
                        },0)
                },
                // 排序方法
                compare(property) {
                        return function (a, b) {
                                var value1 = a[property];
                                var value2 = b[property];
                                return value1 - value2;
                        }
                },
                // 上移
                moveUpSelect(){
                        if(!this.selectionData.length){
                                this.$message({
                                        message: '请选择数据',
                                        type: 'warning'
                                });
                                return;
                        }
                        if(this.selectIds.indexOf(this.taskContentData[0].id)>-1){
                                this.$message({
                                        message: '已经到顶了，无法再移动！',
                                        type: 'warning'
                                });
                                return;
                        }
                        this.loading = true;
                        let temArr = JSON.parse(JSON.stringify(this.taskContentData));
                        // this.selectionData.reverse();
                        this.selectionData.sort(this.compare("$index"));
                        this.taskContentDataIds = []
                        this.taskContentData.forEach(ele=>{
                               this.taskContentDataIds.push(ele.id);
                        })
                        this.selectionData.forEach((ele)=>{

                                let i = this.taskContentDataIds.indexOf(ele.id);
                                if(i>-1){

                                        [this.taskContentDataIds[i-1],this.taskContentDataIds[i]] = [this.taskContentDataIds[i],this.taskContentDataIds[i-1]];
                                        [temArr[i-1],temArr[i]] = [temArr[i],temArr[i-1]]
                                }
                        })
                        setTimeout(()=>{
                                this.taskContentData = temArr;
                                this.loading = false;
                        },0)
                },
                // 下移
                moveDownSelect(){
                        if(!this.selectionData.length){
                                this.$message({
                                        message: '请选择数据',
                                        type: 'warning'
                                });
                                return;
                        }
                        if(this.selectIds.indexOf(this.taskContentData[this.taskContentData.length-1].id)>-1){
                                this.$message({
                                        message: '已经到底了，无法再移动！',
                                        type: 'warning'
                                });
                                return;
                        }

                        this.loading = true;
                        let temArr = JSON.parse(JSON.stringify(this.taskContentData));
                        this.selectionData.sort(this.compare("$index"));
                        this.selectionData.reverse();
                        this.taskContentDataIds = []
                        this.taskContentData.forEach(ele=>{
                               this.taskContentDataIds.push(ele.id);
                        })
                        this.selectionData.forEach((ele)=>{

                                let i = this.taskContentDataIds.indexOf(ele.id);
                                if(i>-1){

                                        [this.taskContentDataIds[i],this.taskContentDataIds[i+1]] = [this.taskContentDataIds[i+1],this.taskContentDataIds[i]];
                                        [temArr[i],temArr[i+1]] = [temArr[i+1],temArr[i]]
                                }
                        })



                        setTimeout(()=>{
                                this.taskContentData = temArr;
                                this.loading = false;
                        },0)

                },
                // 任务内容 选择的数据
                selectionChange(val) {

                        this.selectionData = val;
                        console.log(this.selectionData)
                        let Ids = [];

                        val.forEach((element) => {
                                Ids.push(element.id);
                        });
                        this.selectIds = Ids.join(',');
                },
                // 弹窗关闭前
                handleClose(done){
                        let self = this;
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {
                                if(done){
                                        done();
                                        this.selectTimeFlag = false;

                                }else{
                                        this.selectTimeFlag = false;
                                        self.dialogVisible = false;
                                }
                        })
                        .catch(()=> {
                                if(!done){
                                        this.selectTimeFlag = true;
                                        self.dialogVisible = true;
                                }
                        });
                },
                // 打开弹窗
                openDialog(row){
                        this.id = row.id;
                        this.form = row;
                        this.form.projectId = row.projectId;
                        this.form.type = String(row.type);

                        this.dialogVisible = true;
                        this.selectTimeFlag = true;

                        this.initData(row.id);
                },
                // 初始化数据
                async initData(id){
                        this.loading = true;

                        // 任务提前通知时限单位
                        getDictionary("task_notify_ahead_unit").then(res=>{
                                this.taskNotifyAheadUnitList = res.data;
                        })
                        // 任务过期通知时限单位
                        getDictionary("task_overdue_time_unit").then(res=>{
                                this.taskOverdueTimeUnitList = res.data;
                        })

                        await adjustDetail({id:id}).then(res=>{
                                let data = res.data;
                                this.loading = false;
                                this.form.taskNotifyAheadUnit = String(data.taskNotifyAheadUnit);
                                this.form.taskOverdueTimeUnit = String(data.taskOverdueTimeUnit);
                                setTimeout(()=>{
                                        this.$set(this.form,'taskExecuteForceSequenceFlag',data.taskExecuteForceSequenceFlag);
                                        this.$set(this.form,'taskFinishPicMustFlag',data.taskFinishPicMustFlag);
                                        this.$set(this.form,'taskOverdueCloseFlag',data.taskOverdueCloseFlag);
                                        this.$set(this.form,'taskOverdueSubmitForbidFlag',data.taskOverdueSubmitForbidFlag);
                                        this.$set(this.form,'subTypeId',data.subTypeId)
                                        this.$set(this.form,'standardId',data.standardId)
                                })
                                this.taskContentData = res.data.taskList;
                                if(res.data.type ==3){
                                        this.taskContentData.forEach(item=>{
                                        item.name = item.areaName
                                        item.$deptId = item.deptName
                                })
                                }

                        }).catch(err=>{
                                this.loading = false;
                        })
                        this.loading = false;

                        console.log(this.columnSlot)
                },
                // 新增临时任务
                updateTask(form,done){
                        console.log(form)
                        // return;
                        let param = {
                                id:this.id,
                                taskNotifyAheadUnit:form.taskNotifyAheadUnit,
                                taskOverdueTimeUnit:form.taskOverdueTimeUnit,
                                standardId:form.standardId,

                                taskExecuteForceSequenceFlag:form.taskExecuteForceSequenceFlag,
                                taskFinishPicMustFlag:form.taskFinishPicMustFlag,
                                taskOverdueCloseFlag:form.taskOverdueCloseFlag,
                                taskOverdueSubmitForbidFlag:form.taskOverdueSubmitForbidFlag,


                                taskNotifyAheadNum:form.taskNotifyAheadNum,
                                taskOverdueTimeNum:form.taskOverdueTimeNum,


                        };

                        form.executeDate = this.dayjs(form.executeDate).format("YYYY-MM-DD 00:00:00");
                        param.targetList = [];

                        this.taskContentData.forEach(ele=>{
                                 let obj = {
                                        deviceId:ele.id,
                                        standardId:ele.standardId
                                }
                                param.targetList.push(obj)

                        })
                        updateTask(param).then(res=>{
                                done();
                                this.dialogVisible = false;
                                this.selectTimeFlag = false;
                        })
                        done();

                },

        }
}
</script>

<style lang="scss" >
.taskManagement-editForm{
        .avue-dialog__footer{
                display: flex;
                justify-content:flex-end;
        }
        .el-form-item__error{
                position: relative;
        }
        // .taskContentLabel::before{
        //         content: " * ";
        //         color: #f00;
        // }

}

</style>